import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import { Cog6ToothIcon } from "@heroicons/react/24/outline";

export default function SettingAction({ children }) {
  return (
    <Menu as="div" className="relative inline-block p-2  w-full" style={{ height: "40px" }}>
      <div className={""}>
        <MenuButton className="flex items-center rounded-full bg-gray-100 text-gray-400 hover:text-gray-600 focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100">
          <span className="sr-only">Open options</span>
          <Cog6ToothIcon className="h-5 w-5" aria-hidden="true" />
        </MenuButton>
      </div>

      <MenuItems className="absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-opacity-5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-leave:duration-75 data-enter:ease-out data-leave:ease-in">
        <div className="w-60">{children}</div>
      </MenuItems>
    </Menu>
  );
}
